var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _circle, _circle2, _circle3, _path, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignsSymbols(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 510 510"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__g",
    x1: 177.266,
    x2: 477.986,
    y1: 177.266,
    y2: 477.986,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__h",
    x1: -1941.936,
    x2: -1675.251,
    y1: 186.064,
    y2: 452.75,
    gradientTransform: "rotate(180 -809 255)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__a"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__i",
    x1: 196.755,
    x2: 422.081,
    y1: 196.755,
    y2: 422.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__j",
    x1: 379.744,
    x2: 207.509,
    y1: 385.256,
    y2: 213.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__k",
    x1: 250.122,
    x2: 260.545,
    y1: 87.015,
    y2: 97.438,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__l",
    x1: 250.122,
    x2: 260.545,
    y1: 413.228,
    y2: 423.65,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__m",
    x1: 1314.121,
    x2: 1324.544,
    y1: -2040.984,
    y2: -2030.562,
    gradientTransform: "rotate(90 -277 -1341)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__n",
    x1: 1314.121,
    x2: 1324.544,
    y1: -1714.772,
    y2: -1704.349,
    gradientTransform: "rotate(90 -277 -1341)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__o",
    x1: 972.115,
    x2: 982.537,
    y1: -387.494,
    y2: -377.071,
    gradientTransform: "rotate(29.75 -277.045 -1341.97)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__p",
    x1: 972.115,
    x2: 982.537,
    y1: -61.281,
    y2: -50.859,
    gradientTransform: "rotate(29.75 -277.045 -1341.97)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__q",
    x1: 839.612,
    x2: 850.035,
    y1: -2762.977,
    y2: -2752.554,
    gradientTransform: "rotate(119.74 -276.973 -1341.625)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__r",
    x1: 839.612,
    x2: 850.035,
    y1: -2436.764,
    y2: -2426.342,
    gradientTransform: "rotate(119.74 -276.973 -1341.625)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__s",
    x1: 48.421,
    x2: 58.844,
    y1: 140.604,
    y2: 151.026,
    gradientTransform: "scale(-1 1) rotate(29.75 .033 -298.616)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__t",
    x1: 48.421,
    x2: 58.844,
    y1: 466.816,
    y2: 477.239,
    gradientTransform: "scale(-1 1) rotate(29.75 .033 -298.616)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__u",
    x1: 1367.71,
    x2: 1378.133,
    y1: -1839.283,
    y2: -1828.861,
    gradientTransform: "scale(1 -1) rotate(-60.26 2034.556 .227)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__v",
    x1: 1367.71,
    x2: 1378.133,
    y1: -1513.071,
    y2: -1502.649,
    gradientTransform: "scale(1 -1) rotate(-60.26 2034.556 .227)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__b"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__w",
    x1: 276.555,
    x2: 375.555,
    y1: 66.521,
    y2: 237.521,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__c"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__x",
    x1: 305.663,
    x2: 652.146,
    y1: 215.155,
    y2: 338.149,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__d"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__y",
    x1: 360,
    x2: 215.986,
    y1: 221.883,
    y2: 221.883,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__d"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__z",
    x1: 421.569,
    x2: 378.352,
    y1: 397.681,
    y2: 354.465,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__d"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0d5"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__A",
    x1: -1726.439,
    x2: -1658.872,
    y1: 2125.26,
    y2: 2125.26,
    gradientTransform: "scale(-1 1) rotate(45 1061.298 2833.719)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__e"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__B",
    x1: -2004.7,
    x2: -1838.864,
    y1: 309.752,
    y2: 309.752,
    gradientTransform: "matrix(-1 0 0 1 -1612.03 0)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__a"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__C",
    x1: -1903.583,
    x2: -1951.814,
    y1: 331.201,
    y2: 282.97,
    gradientTransform: "matrix(-1 0 0 1 -1612.03 0)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__a"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__D",
    x1: -1694.695,
    x2: -1677.455,
    y1: 2158.926,
    y2: 2158.926,
    gradientTransform: "scale(-1 1) rotate(45 1061.298 2833.719)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__f"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__E",
    x1: 23.21,
    x2: 90.777,
    y1: 1532.232,
    y2: 1532.232,
    gradientTransform: "matrix(1 0 0 -1 198.007 1604.552)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__e"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__F",
    x1: -349.083,
    x2: -183.246,
    y1: 1128.488,
    y2: 1128.488,
    gradientTransform: "scale(1 -1) rotate(-45 -1582.977 -153.916)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__a"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__G",
    x1: -247.966,
    x2: -296.197,
    y1: 1149.937,
    y2: 1101.706,
    gradientTransform: "scale(1 -1) rotate(-45 -1582.977 -153.916)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__a"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__H",
    x1: 54.954,
    x2: 72.194,
    y1: 1567.155,
    y2: 1567.155,
    gradientTransform: "matrix(1 0 0 -1 198.007 1604.552)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__f"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "signs-symbols_svg__I",
    x1: 242.314,
    x2: 291.39,
    y1: 242.314,
    y2: 291.39,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#signs-symbols_svg__c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    r: 255,
    fill: "url(#signs-symbols_svg__g)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    r: 226.141,
    fill: "url(#signs-symbols_svg__h)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    r: 191.069,
    fill: "url(#signs-symbols_svg__i)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__j)",
    d: "M226.834 285.633l176.672 176.672a256.468 256.468 0 0054.101-52.473l-174.72-174.719z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 91.893,
    r: 12.424,
    fill: "url(#signs-symbols_svg__k)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 418.105,
    r: 12.424,
    fill: "url(#signs-symbols_svg__l)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.106,
    cy: 254.999,
    r: 12.424,
    fill: "url(#signs-symbols_svg__m)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.894,
    cy: 254.999,
    r: 12.424,
    fill: "url(#signs-symbols_svg__n)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.955,
    cy: 113.402,
    r: 12.424,
    fill: "url(#signs-symbols_svg__o)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.045,
    cy: 396.597,
    r: 12.424,
    fill: "url(#signs-symbols_svg__p)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.598,
    cy: 335.954,
    r: 12.424,
    fill: "url(#signs-symbols_svg__q)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.402,
    cy: 174.045,
    r: 12.424,
    fill: "url(#signs-symbols_svg__r)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.045,
    cy: 113.402,
    r: 12.424,
    fill: "url(#signs-symbols_svg__s)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.955,
    cy: 396.597,
    r: 12.424,
    fill: "url(#signs-symbols_svg__t)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.402,
    cy: 335.954,
    r: 12.424,
    fill: "url(#signs-symbols_svg__u)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.598,
    cy: 174.045,
    r: 12.424,
    fill: "url(#signs-symbols_svg__v)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__w)",
    d: "M255 28.859V255l159.906 159.906c40.923-40.923 66.235-97.459 66.235-159.906 0-124.894-101.247-226.141-226.141-226.141z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__x)",
    d: "M255 63.931V255l135.106 135.106c34.577-34.577 55.963-82.344 55.963-135.106 0-105.525-85.544-191.069-191.069-191.069z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__y)",
    d: "M256.519 28.879c-.507-.003-1.011-.019-1.519-.019V255l159.906 159.906c40.923-40.923 66.235-97.459 66.235-159.906 0-.508-.016-1.012-.019-1.519z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__z)",
    d: "M392.671 344.896l22.079 69.854.156.156a227.327 227.327 0 0022.095-25.68z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__A)",
    d: "M392.671 344.894l18.605 52.045.772 14.294c1.147 3.209-15.109.043-15.109.043l-52.045-18.605c-13.232-13.233 34.545-61.01 47.777-47.777z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__B)",
    d: "M229.535 277.319l115.361 115.352c1.308-2.267 3.296-4.273 5.842-5.694 3.479-1.927 8.92-.872 12.687.27.82.244 1.57-.183 1.875-.837.192-.392.227-.872.017-1.343-.009 0-.009-.009-.009-.009-.209-.48-.392-.968-.549-1.456l-.209-.706c-.009-.017-.009-.026-.009-.044a14.74 14.74 0 01-.419-2.293 14.802 14.802 0 01-.073-2.031 14.903 14.903 0 014.381-10.098 14.922 14.922 0 0112.129-4.307c.776.078 1.543.218 2.293.419a.08.08 0 01.044.009l.706.209c.253.079.497.166.741.262.235.087.471.183.706.288.009 0 .009 0 .017.009.471.209.95.174 1.343-.017a1.556 1.556 0 00.837-1.875c-1.142-3.767-2.197-9.199-.27-12.678 1.421-2.555 3.418-4.543 5.694-5.851L277.319 229.535c-3.61-3.601-9.452-3.601-13.053 0l-6.81 6.81-21.11 21.11-6.81 6.81c-3.602 3.602-3.602 9.444-.001 13.054z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__C)",
    d: "M236.345 257.455L365.3 386.41c.192-.392.227-.872.017-1.343-.009 0-.009-.009-.009-.009-.209-.48-1.116-3.732-1.186-4.499a7.833 7.833 0 01-.061-.767 14.924 14.924 0 014.369-11.361 14.922 14.922 0 0111.362-4.368c.253.009.506.026.767.061.767.07 1.535.209 2.293.419a.08.08 0 01.044.009 42.24 42.24 0 012.171.768c.471.209.95.174 1.343-.017L257.455 236.345z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__D)",
    d: "M402.993 402.993a33.246 33.246 0 018.283-6.054l5.105 14.281c1.147 3.209-1.952 6.308-5.161 5.161l-14.281-5.105a33.246 33.246 0 016.054-8.283z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__E)",
    d: "M221.216 94.59l23.645-49.957s8.68-11.131 10.138-8.051l10.138 8.05 23.645 49.957c.001 18.714-67.566 18.714-67.566.001z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__F)",
    d: "M288.788 257.727l-.006-163.139c-2.528.678-5.352.691-8.157-.105-3.823-1.098-6.924-5.691-8.78-9.162a1.557 1.557 0 00-1.918-.734 1.569 1.569 0 00-.962.937c.006.006 0 .012 0 .012-.191.487-.407.962-.641 1.418l-.351.647a.074.074 0 01-.025.037 14.764 14.764 0 01-1.326 1.918c-.16.197-.333.395-.499.586a14.904 14.904 0 01-8.842 4.772c-.746.117-1.504.173-2.281.173s-1.535-.056-2.281-.173a14.927 14.927 0 01-9.341-5.358 14.547 14.547 0 01-1.326-1.918.081.081 0 01-.025-.037l-.351-.647a10.693 10.693 0 01-.339-.709 12.045 12.045 0 01-.296-.703c-.006-.006-.006-.006-.006-.019a1.569 1.569 0 00-.962-.937 1.557 1.557 0 00-1.918.734c-1.856 3.471-4.951 8.059-8.774 9.156-2.812.801-5.629.795-8.163.111l-.006 163.139c.006 5.099 4.137 9.23 9.23 9.23h49.116c5.093.001 9.224-4.13 9.23-9.229z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__G)",
    d: "M269.927 266.957V84.588a1.569 1.569 0 00-.962.937c.006.006 0 .012 0 .012-.191.487-1.85 3.428-2.343 4.02-.16.21-.327.401-.499.586A14.927 14.927 0 01255 95.088a14.927 14.927 0 01-11.123-4.945 7.568 7.568 0 01-.499-.586 13.117 13.117 0 01-1.326-1.918.081.081 0 01-.025-.037 43.432 43.432 0 01-.987-2.059c-.006-.006-.006-.006-.006-.019a1.569 1.569 0 00-.962-.937v182.37z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#signs-symbols_svg__H)",
    d: "M255 46.209c-3.55 0-6.957-.56-10.138-1.576l6.488-13.708c1.458-3.08 5.841-3.08 7.299 0l6.488 13.708A33.267 33.267 0 01255 46.209z"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    r: 41.615,
    fill: "url(#signs-symbols_svg__I)"
  })));
}
export default __webpack_public_path__ + "static/signs-symbols.2d890246.svg";
export { SvgSignsSymbols as ReactComponent };